import React from "react";
import { Col, Container, Row } from "reactstrap";

import featuresContent from "@/data/features-content.json";
import Image from "next/image";
import classes from "@/styles/invitation/feature-section.module.css";
const FeatureSections = () => {
  return (
    <>
      {featuresContent.map((feature, index) => (
        <section className="my-5 py-5" key={index}>
          <Container>
            <Row>
              {feature.even ? (
                <>
                  <Col
                    className="d-flex justify-content-center align-items-center"
                    xs={12}
                    lg={6}
                  >
                    <div>
                      <h4>{feature.title}</h4>
                      <p>{feature.description}</p>
                      <Row>
                        {feature.points.map(({ title, description }, i) => (
                          <Col xs={12} lg={6} key={title}>
                            <p className="fw-bold mb-2">{title}</p>
                            <p>{description}</p>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </Col>
                  <Col
                    className={`d-flex justify-content-center align-items-center ${classes.imgCol}`}
                    xs={12}
                    lg={6}
                  >
                    <div className="">
                      <Image
                        src={feature.illustrationUrl}
                        alt={feature.illustrationAlt}
                        height={300}
                        width={400}
                      />
                    </div>
                  </Col>
                </>
              ) : (
                <>
                  <Col
                    className={`d-flex justify-content-center align-items-center ${classes.imgCol}`}
                    xs={12}
                    lg={6}
                  >
                    <div className="">
                      <Image
                        src={feature.illustrationUrl}
                        alt={feature.illustrationAlt}
                        height={300}
                        width={400}
                      />
                    </div>
                  </Col>
                  <Col
                    className="d-flex justify-content-center align-items-center"
                    xs={12}
                    lg={6}
                  >
                    <div>
                      <h4>{feature.title}</h4>
                      <p>{feature.description}</p>
                      <Row>
                        {feature.points.map(({ title, description }, i) => (
                          <Col xs={12} lg={6} key={title}>
                            <p className="fw-bold mb-2">{title}</p>
                            <p>{description}</p>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </Col>
                </>
              )}
            </Row>
          </Container>
        </section>
      ))}
    </>
  );
};

export default FeatureSections;
